import React from 'react';
import { formatNumber } from '../../../../../shared/utils/numberFormatter';

const TransactionVolumeCards = ({ data, isLoading }) => {
  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE",
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  const cards = [
    {
      title: 'Last 7 Days',
      value: data?.volumeLast7Days || 0
    },
    {
      title: 'Last 30 Days',
      value: data?.volumeLast30Days || 0
    },
    {
      title: 'Last Year',
      value: data?.volumeLastYear || 0
    },
    {
      title: 'Lifetime',
      value: data?.volumeLifetime || 0
    }
  ];

  if (isLoading) {
    return (
      <div 
        className="p-2 md:p-3"
        style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
      >
        <div className="mb-2">
          <h3 
            className="text-sm font-medium"
            style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
          >
            Transaction Volume
          </h3>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="p-4"
              style={{ backgroundColor: styles.secondaryBg + '20', border: `1px solid ${styles.borderColor}` }}
            >
              <div className="animate-pulse">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-8 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div 
      className="p-2 md:p-3 flex flex-col"
      style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
    >
      <div className="mb-2">
        <h3 
          className="text-sm font-medium"
          style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
        >
          Transaction Volume
        </h3>
      </div>
      <div className="grid grid-cols-2 gap-4 flex-1">
        {cards.map((card, index) => (
          <div
            key={index}
            className="p-4 flex items-center justify-center"
            style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}
          >
            <div className="flex flex-col items-center justify-center text-center">
              <div
                className="text-2xl font-semibold mb-1"
                style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}
              >
                {formatNumber(card.value)}
              </div>
              <div
                className="text-xs"
                style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}
              >
                {card.title}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Average and Median Volume */}
      {data?.avgVolume !== undefined && data?.medianVolume !== undefined && (
        <div className="flex justify-around items-center mt-1 pt-1" style={{ borderTop: `1px solid ${styles.borderColor}` }}>
          <div className="text-center">
            <div className="text-xs mb-1" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
              Average Volume
            </div>
            <div className="text-sm font-medium" style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}>
              {formatNumber(data.avgVolume)}
            </div>
          </div>
          <div className="text-center">
            <div className="text-xs mb-1" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
              Median Volume
            </div>
            <div className="text-sm font-medium" style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}>
              {formatNumber(data.medianVolume)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionVolumeCards;

